<template>
  <div>
    <v-card :loading="loading" :disabled="loading">
      <v-card-title>
        <span v-if="!passed_list_mode">{{
          $t("applicants_report_list.title")
        }}</span>
        <span v-if="passed_list_mode">{{
          $t("applicants_report_list.passed_title")
        }}</span>
      </v-card-title>

      <v-card-text>
        <v-divider></v-divider>
        <v-card color="#2A3B4D" dark>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-text class="text-decoration">
                <span class="mr-5">
                  {{ $t("applicants_report_list.year") }} :
                  <span class="deep-orange--text"
                    >{{ SEMESTER }} / {{ YEAR }}</span
                  >
                </span>
                {{ $t("applicants_report_list.round") }} :
                <span class="deep-orange--text">
                  {{
                    inlineTranslator({
                      en: ROUND_NAME_EN,
                      th: ROUND_NAME_TH,
                    })
                  }}
                </span>
                <span>
                  <br />
                  {{ $t("applicants_report_list.project") }} :
                </span>
                <span class="deep-orange--text">
                  {{
                    inlineTranslator({
                      en: PROJECT_NAME_EN,
                      th: PROJECT_NAME_TH,
                    })
                  }}</span
                >
                <br />
                {{ $t("applicants_report_list.faculty") }} :
                <span class="deep-orange--text">
                  {{
                    inlineTranslator({
                      en: FACULTY_NAME_EN,
                      th: FACULTY_NAME_TH,
                    })
                  }}
                </span>
                <br />
                {{ $t("applicants_report_list.curriculum") }} :
                <span class="deep-orange--text">
                  {{
                    inlineTranslator({
                      en: CURRICULUM_NAME_EN,
                      th: CURRICULUM_NAME_TH,
                    })
                  }}</span
                >
                <span v-if="BRANCH_NAME_TH">
                  {{ $t("number_of_applicants_by_order_report.branch") }}
                  {{
                    inlineTranslator({
                      en: BRANCH_NAME_EN,
                      th: BRANCH_NAME_TH,
                    })
                  }}</span
                >
                <br />
                <div v-if="LEVEL_ID === '2' || LEVEL_ID == '3'">
                  {{ $t("program_list.study_admit_type") }} :
                  <span class="deep-orange--text">
                    {{
                      inlineTranslator({
                        en: STUDY_ADMIT_TYPE_NAME_EN,
                        th: STUDY_ADMIT_TYPE_NAME_TH,
                      })
                    }}
                  </span>
                  | {{ $t("program_list.study_plan") }} :
                  <span class="deep-orange--text">
                    {{
                      inlineTranslator({
                        en: STUDY_PLAN_NAME_EN,
                        th: STUDY_PLAN_NAME_TH,
                      })
                    }}
                  </span>
                  | {{ $t("program_list.study_classes") }} :
                  <span class="deep-orange--text">
                    {{
                      inlineTranslator({
                        en: STUDY_CLASSES_NAME_EN,
                        th: STUDY_CLASSES_NAME_TH,
                      })
                    }}
                  </span>
                  | {{ $t("program_list.specific_nation") }} :
                  <span class="deep-orange--text">
                    {{
                      inlineTranslator({
                        en: SPECIFIC_NATION_NAME_EN,
                        th: SPECIFIC_NATION_NAME_TH,
                      })
                    }}
                  </span>
                  <br />
                </div>
                <div v-if="!passed_list_mode">
                  {{ $t("applicants_report_list.type_data") }} :
                  <span class="deep-orange--text">{{
                    inlineTranslator({
                      en: TYPE_DATA_EN,
                      th: TYPE_DATA_TH,
                    })
                  }}</span>
                </div>
              </v-card-text>
            </div>
          </div>
        </v-card>

        <div class="my-5">
          <span v-if="!detail_mode && !set_pass_mode">
            <v-btn
              elevation="0"
              color="green"
              @click="downloadExcel"
              class="white--text"
            >
              <v-icon class="mr-1">mdi-microsoft-excel</v-icon>
              Download
            </v-btn>

            <v-btn
              v-if="!passed_list_mode"
              outlined
              color="deep-orange"
              @click="activate_detail_page(true)"
              class="ml-5"
            >
              ดูข้อมูลเพิ่มเติมอย่างละเอียด
            </v-btn>
          </span>

          <span v-if="detail_mode">
            <h3 class="mt-5 mb-3">เลือกข้อมูลข้างล่าง</h3>

            <SelectDataToShow ref="data_selector" />

            <div class="my-5">
              <v-btn
                outlined
                color="deep-orange"
                @click="activate_detail_page(false)"
              >
                กลับไปดูข้อมูลรายชื่อ
              </v-btn>

              <v-btn outlined color="blue" class="ml-5" @click="search_detail">
                ค้นหา
              </v-btn>

              <v-btn
                elevation="0"
                color="green"
                @click="downloadExcel"
                class="ml-5 white--text"
                :disabled="list_applicant_additional_data.length === 0"
              >
                <v-icon class="mr-1">mdi-microsoft-excel</v-icon>
                Download
              </v-btn>
            </div>
          </span>
        </div>

        <div class="my-5" v-if="selective_mode && !detail_mode">
          <span v-if="!set_status_mode_available" class="teal--text"
            >* การคัดเลือกผู้ผ่านต้องเลือกแบบแยกโครงการ และแยกหลักสูตร</span
          >
          <span v-if="!set_pass_mode && set_status_mode_available">
            <v-btn
              color="deep-purple white--text"
              @click="activate_set_pass_page(true)"
            >
              ตั้งค่าผู้ที่ผ่านการคัดเลือก
            </v-btn>
          </span>

          <span
            v-if="
              !set_pass_mode && !show_pass_mode && set_status_mode_available
            "
          >
            <v-btn
              color="deep-purple"
              outlined
              @click="activate_show_pass_page(true)"
              class="ml-5 "
            >
              ดูสถานะการคัดเลือก
            </v-btn>
          </span>

          <span v-if="!set_pass_mode && show_pass_mode">
            <v-btn
              color="black"
              outlined
              @click="activate_show_pass_page(false)"
              class="ml-5 "
            >
              ไม่แสดงการคัดเลือก
            </v-btn>
          </span>

          <span v-if="set_pass_mode">
            <v-btn
              outlined
              color="deep-purple"
              @click="activate_set_pass_page(false)"
            >
              กลับไปดูข้อมูลรายชื่อ
            </v-btn>
          </span>
        </div>

        <div class="my-5" v-if="passed_list_mode">
          <v-btn
            class="white--text red"
            @click="cancel_dialog = true"
            :disabled="!already_confirm"
          >
            ยกเลิกการยืนยันฉบับสมบูรณ์
          </v-btn>
          <v-btn
            color="indigo"
            class="ml-5 white--text"
            @click="(e) => (open_lock_confirm = true)"
          >
            ยืนยันฉบับสมบูรณ์
          </v-btn>
          <span v-if="already_confirm" class="ml-5">
            ยืนยันฉบับสมบูรณ์ล่าสุด เมื่อ
            {{ current_curr_index_data.CONFIRMED_TIMESTAMP }}
          </span>
        </div>

        <div class="my-5" v-if="passed_list_mode">
          <v-btn
            class="white--text cyan"
            @click="publish_dialog = true"
            :disabled="!can_cancel_and_publish || !already_confirm"
          >
            ประกาศผลผู้สมัคร
          </v-btn>
          <span v-if="already_publish" class="ml-5">
            ประกาศผลล่าสุด เมื่อ
            {{ current_curr_index_data.APPLIED_TIMESTAMP }}
          </span>
        </div>

        <!-- --------------------------------------------------------------------------------------- -->
        <!-- สูตรคำนวณ GAT / PAT -->
        <div
          v-if="display_gat_pat && current_curr_index_data"
          class="mt-5 text-center"
        >
          <h2 class="font-weight-medium mb-2">
            <span>สูตรการคำนวณคะแนน : </span>
            <span class="deep-orange--text font-weight-bold">{{
              weight_calculate_text
            }}</span>
          </h2>
          <h2 class="font-weight-medium">
            <span>จำนวนรับตามประกาศ : </span>
            <span class="deep-orange--text font-weight-bold">{{
              current_curr_index_data.gat_pat_quota
            }}</span>
            <span> คน</span>
          </h2>
        </div>
        <!-- --------------------------------------------------------------------------------------- -->

        <v-simple-table
          class="mb-5 mt-5"
          dense
          height="520"
          fixed-header
          v-show="!detail_mode || list_applicant_additional_data.length > 0"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <!-- //------------------------------------------- -->
                <th
                  v-for="(field, i) in filtered_data_field"
                  :key="i"
                  class="text-center blue-grey darken-1 white--text font-weight-light"
                >
                  <span v-if="field.use_translate">{{ $t(field.text) }}</span>
                  <span v-if="!field.use_translate">{{ field.text }}</span>
                </th>
                <!-- //------------------------------------------- -->
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in detail_mode
                  ? list_applicant_additional_data
                  : list_applicant"
                v-bind:key="index"
              >
                <td
                  v-for="field in filtered_data_field"
                  :key="field.key_name"
                  :class="'text-' + field.text_mode"
                  :style="style_by_status(item.regis_status)"
                >
                  <!-- ==DISPLAY== -->
                  <!-- ----------------------------------------------- -->
                  <!-- 1 -->
                  <div v-if="field.key_name === '1'">{{ index + 1 }}</div>
                  <!-- ----------------------------------------------- -->
                  <!-- 2 -->
                  <div v-if="field.key_name === '2'">
                    <router-link
                      v-if="LEVEL_ID === '1'"
                      target="_blank"
                      :title="'คลิกเพื่อดูใบสมัคร'"
                      :to="{
                        path:
                          'application_pdf_undergraduate' +
                          '/' +
                          item.REGISTER_ID,
                        query: { uid: item.UID },
                      }"
                      >{{ item.REGISTER_ID }}</router-link
                    >
                    <router-link
                      v-if="LEVEL_ID === '2' || LEVEL_ID === '3'"
                      target="_blank"
                      :title="'คลิกเพื่อดูใบสมัคร'"
                      :to="{
                        path:
                          'application_pdf_graduate' + '/' + item.REGISTER_ID,
                        query: { uid: item.UID },
                      }"
                      >{{ item.REGISTER_ID }}</router-link
                    >
                    <v-btn
                      x-small
                      dense
                      elevation="0"
                      color="light-blue lighten-2"
                      class="ml-2"
                      :href="file_path + item.REGISTER_ID"
                      target="_blank"
                      v-if="item.ADDITIONAL_FILE == 1"
                      >{{ $t("applicants_report_list.file_upload") }}
                    </v-btn>
                  </div>
                  <!-- ----------------------------------------------- -->
                  <!-- 3 -->
                  <div v-if="field.key_name === '3'">
                    {{ objectTranslator(item, "INITIALS") }}
                    {{ objectTranslator(item, "STUDENT_FNAME") }}
                    {{ objectTranslator(item, "STUDENT_LNAME") }}
                  </div>
                  <!-- ----------------------------------------------- -->
                  <div v-if="field.key_name === 'name_surname_eng'">
                    {{ item.INITIALS_EN }}
                    {{ item.STUDENT_FNAME_EN }}
                    {{ item.STUDENT_LNAME_EN }}
                  </div>
                  <!-- ----------------------------------------------- -->
                  <div v-if="field.key_name === 'applied_timestamp'">
                    {{ item.APPLIED_TIMESTAMP ? item.APPLIED_TIMESTAMP : "-" }}
                  </div>
                  <!-- ----------------------------------------------- -->
                  <!-- 5 -->
                  <div v-if="field.key_name === '5'">
                    <span
                      class="mr-5"
                      v-if="is_editable(item.regis_status) && set_pass_mode"
                    >
                      <v-btn
                        class="mr-3"
                        x-small
                        color="green"
                        @click="set_status(item, true)"
                        >ผ่าน</v-btn
                      >
                      <v-btn
                        class="mr-3"
                        x-small
                        color="red"
                        @click="set_status(item, false)"
                        >ไม่ผ่าน</v-btn
                      >
                      <v-btn
                        v-if="LEVEL_ID === '2' || LEVEL_ID === '3'"
                        class="mr-3"
                        x-small
                        color="yellow"
                        @click="set_pause_status(item, true)"
                        >รอ</v-btn
                      >
                    </span>
                    <span
                      v-if="
                        show_pass_mode &&
                          !item.not_set &&
                          item.passed &&
                          !item.paused
                      "
                      >ผ่าน</span
                    >
                    <span
                      v-if="
                        show_pass_mode &&
                          !item.not_set &&
                          !item.passed &&
                          !item.paused &&
                          get_pass_order(item.regis_status) === '-'
                      "
                      >ไม่ผ่าน</span
                    >
                    <span
                      v-if="
                        show_pass_mode &&
                          !item.not_set &&
                          item.paused &&
                          get_pass_order(item.regis_status) === '-'
                      "
                    >
                      รอ</span
                    >
                    <span
                      v-if="
                        show_pass_mode &&
                          !item.passed &&
                          get_pass_order(item.regis_status) !== '-'
                      "
                      >(ติดสาขาที่เลือกลำดับที่
                      {{ get_pass_order(item.regis_status) }})</span
                    >
                  </div>
                  <!-- 9 Notice -->
                  <div v-if="field.key_name === 'notice_passed_order'">
                    <span>ติดสาขาที่เลือกลำดับที่ {{ item.ORDER }}</span>
                  </div>
                  <!-- ----------------------------------------------- -->
                  <!-- Normal----- -->
                  <div v-if="field.display_mode === 'normal'">
                    {{ item[field.data_name] }}
                  </div>
                  <!-- ----------------------------------------------- -->
                  <!-- Object Translate -->
                  <div v-if="field.display_mode === 'object_translator'">
                    {{ objectTranslator(item, field.data_name) }}
                  </div>
                  <!-- ----------------------------------------------- -->
                  <!-- แสดงเฉพาะระดับบัณฑิตศึกษา -->
                  <div
                    v-if="
                      (LEVEL_ID === '2' || LEVEL_ID === '3') &&
                        item.regis_status &&
                        item.regis_status[0]
                    "
                  >
                    <div v-if="field.key_name === 'graduate_inter'">
                      <v-checkbox
                        color="primary"
                        v-model="item.regis_status[0].PAYMENT_INTER_RATE"
                        false-value="0"
                        true-value="1"
                        @change="(e) => update_inter(item, index, e)"
                      ></v-checkbox>
                    </div>
                    <div v-if="field.key_name === 'graduate_package_fee'">
                      <v-text-field
                        v-model="item.regis_status[0].PAYMENT_CONFIRM_FEE"
                        dense
                        hide-details
                        solo
                      ></v-text-field>
                    </div>
                    <div
                      v-if="
                        field.key_name === 'graduate_package_fee_pay_difference'
                      "
                    >
                      <v-text-field
                        v-model="item.regis_status[0].PAYMENT_DISCOUNT_FEE"
                        dense
                        hide-details
                        outlined
                      ></v-text-field>
                    </div>
                    <div
                      v-if="
                        field.key_name ===
                          'graduate_package_fee_pay_difference_text'
                      "
                    >
                      <v-text-field
                        v-model="
                          item.regis_status[0].PAYMENT_DISCOUNT_DESCRIPTION
                        "
                        dense
                        hide-details
                        filled
                      ></v-text-field>
                    </div>
                    <div v-if="field.key_name === 'graduate_save'">
                      <v-btn
                        class="mr-3"
                        x-small
                        color="primary"
                        @click="save_payment(item)"
                        >บันทึกข้อมูล</v-btn
                      >
                    </div>
                  </div>
                  <!-- ----------------------------------------------- -->
                  <!-- GAT PAT -->
                  <div
                    v-if="
                      field.mode === 'gat_pat' &&
                        current_curr_index_data &&
                        item.gat_pat &&
                        item.gat_pat[field.data_name]
                    "
                  >
                    <span
                      v-if="field.key_name === 'gat_pat_score_summary'"
                      class="indigo--text font-weight-bold"
                    >
                      {{ parseFloat(item.gat_pat[field.data_name]).toFixed(2) }}
                    </span>
                    <span
                      v-else-if="current_curr_index_data[field.field_name]"
                      class="deep-orange--text font-weight-bold"
                    >
                      {{ item.gat_pat[field.data_name] }}
                    </span>
                    <span v-else>
                      {{ item.gat_pat[field.data_name] }}
                    </span>
                  </div>
                  <!-- ----------------------------------------------- -->
                </td>
                <!---------------------------------------------------------->
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <div class="mb-5">
          <v-btn
            dense
            elevation="0"
            color="light-blue darken-4"
            class="white--text"
            :disabled="!isAdditionalFilesExists"
            :href="getDownloadAdditionalFilesPath"
            target="_blank"
          >
            ดาวน์โหลดไฟล์แนบใบสมัครทั้งหมด
          </v-btn>
        </div>

        <div class="text-left font-weight-black indigo--text" colspan="6">
          {{ $t("applicants_report_list.total") }} {{ COUNT_TOTAL }}
          {{ $t("applicants_report_list.unit") }}
        </div>
      </v-card-text>
    </v-card>

    <v-dialog max-width="500" v-model="open_lock_confirm">
      <v-card>
        <v-card-title>ยืนยันฉบับสมบูรณ์</v-card-title>
        <v-card-text>เมื่อยืนยันแล้ว จะไม่สามารถแก้ไขข้อมูลได้อีก</v-card-text>
        <v-card-actions>
          <v-btn dark color="green" @click="confirm_lock(true)">ยืนยัน</v-btn>
          <v-btn
            outlined
            color="red"
            class="ml-4"
            @click="(e) => (open_lock_confirm = false)"
            >ปิด</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="500" v-model="cancel_dialog">
      <v-card>
        <v-card-title>ยกเลิกฉบับสมบูรณ์</v-card-title>
        <v-card-text>ยืนยัน</v-card-text>
        <v-card-actions>
          <v-btn dark color="green" @click="confirm_lock(false)">ยืนยัน</v-btn>
          <v-btn
            outlined
            color="red"
            class="ml-4"
            @click="(e) => (cancel_dialog = false)"
            >ปิด</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="500" v-model="publish_dialog">
      <v-card color="red">
        <v-card-title class="white--text">ประกาศผลผู้สมัคร</v-card-title>
        <v-card-text class="white--text"
          >เมื่อยืนยัน ระบบจะแสดงข้อมูลสถานะให้ผู้สมัครทราบ
          และไม่สามารถเปลี่ยนแปลงได้อีก</v-card-text
        >
        <v-card-actions>
          <v-btn
            dark
            color="green"
            v-if="LEVEL_ID === '2' || LEVEL_ID === '3'"
            @click="publish()"
            >ยืนยัน</v-btn
          >
          <v-btn
            dark
            color="green"
            v-if="LEVEL_ID === '1'"
            @click="publish('4')"
            >ประกาศเข้าระบบเคลียริ่งเฮาส์</v-btn
          >
          <v-btn
            dark
            color="green"
            v-if="LEVEL_ID === '1'"
            @click="publish('5')"
            >ประกาศไปยืนยันสิทธิ์</v-btn
          >
          <v-btn
            outlined
            color="white"
            class="ml-4"
            @click="(e) => (publish_dialog = false)"
            >ปิด</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ReportsProvider from "@/services/reports.provider";
// import FacultyProvider from "@/services/faculty.provider";
import { objectTranslator, inlineTranslator } from "@/helper/translator";

import SelectDataToShow from "./SelectDataToShow";
import { getById } from "@/helper/filter";
import data_field from "./data_field";
import { exportExcel } from "./export_excel";

const reportsService = new ReportsProvider();
// const facultyService = new FacultyProvider();

export default {
  name: "ApplicantsReportList",
  props: {
    params: {
      type: Object,
    },
  },
  data() {
    return {
      current_curr_index_data: null,
      open_lock_confirm: false,
      passed_list_mode: false,
      selective_mode: false,
      thead_class:
        "text-center blue-grey darken-1 white--text font-weight-light",
      loading: false,
      list_applicant: [],
      list_applicant_additional_data: [],
      detail_mode: false,
      set_pass_mode: false,
      show_pass_mode: false,
      set_status_mode_available: false,
      selected_data: {},
      url_data: null,

      LEVEL_ID: null,
      YEAR: null,
      SEMESTER: null,
      ROUND_NAME_TH: null,
      ROUND_NAME_EN: null,
      PROJECT_NAME_TH: null,
      PROJECT_NAME_EN: null,
      FACULTY_NAME_TH: null,
      FACULTY_NAME_EN: null,
      CURRICULUM_NAME_TH: null,
      CURRICULUM_NAME_EN: null,
      BRANCH_NAME_TH: null,
      BRANCH_NAME_EN: null,

      STUDY_ADMIT_TYPE_NAME_EN: null,
      STUDY_ADMIT_TYPE_NAME_TH: null,
      STUDY_PLAN_NAME_EN: null,
      STUDY_PLAN_NAME_TH: null,
      STUDY_CLASSES_NAME_EN: null,
      STUDY_CLASSES_NAME_TH: null,
      SPECIFIC_NATION_NAME_EN: null,
      SPECIFIC_NATION_NAME_TH: null,

      cache_getPreExecutedNameListSummary: null,
      cache_getNameListSummary: null,

      TYPE_DATA_TH: null,
      TYPE_DATA_EN: null,
      COUNT_TOTAL: null,

      data_field,

      cancel_dialog: false,
      publish_dialog: false,

      display_gat_pat: false,
    };
  },
  components: {
    SelectDataToShow,
  },
  computed: {
    weight_calculate_text() {
      let first = true;
      let ret = "";
      if (!this.current_curr_index_data) return "";
      if (this.current_curr_index_data.GAT_WEIGHT) {
        if (first) first = false;
        else ret += " + ";
        ret += "(GAT * " + this.current_curr_index_data.GAT_WEIGHT + "%)";
      }
      if (this.current_curr_index_data.GAT_1_WEIGHT) {
        if (first) first = false;
        else ret += " + ";
        ret += "(GAT1 * " + this.current_curr_index_data.GAT_1_WEIGHT + "%)";
      }
      if (this.current_curr_index_data.GAT_2_WEIGHT) {
        if (first) first = false;
        else ret += " + ";
        ret += "(GAT2 * " + this.current_curr_index_data.GAT_2_WEIGHT + "%)";
      }
      if (this.current_curr_index_data.PAT_1_WEIGHT) {
        if (first) first = false;
        else ret += " + ";
        ret += "(PAT1 * " + this.current_curr_index_data.PAT_1_WEIGHT + "%)";
      }
      if (this.current_curr_index_data.PAT_2_WEIGHT) {
        if (first) first = false;
        else ret += " + ";
        ret += "(PAT2 * " + this.current_curr_index_data.PAT_2_WEIGHT + "%)";
      }
      if (this.current_curr_index_data.PAT_3_WEIGHT) {
        if (first) first = false;
        else ret += " + ";
        ret += "(PAT3 * " + this.current_curr_index_data.PAT_3_WEIGHT + "%)";
      }
      if (this.current_curr_index_data.PAT_4_WEIGHT) {
        if (first) first = false;
        else ret += " + ";
        ret += "(PAT4 * " + this.current_curr_index_data.PAT_4_WEIGHT + "%)";
      }
      if (this.current_curr_index_data.PAT_5_WEIGHT) {
        if (first) first = false;
        else ret += " + ";
        ret += "(PAT5 * " + this.current_curr_index_data.PAT_5_WEIGHT + "%)";
      }
      if (this.current_curr_index_data.PAT_6_WEIGHT) {
        if (first) first = false;
        else ret += " + ";
        ret += "(PAT6 * " + this.current_curr_index_data.PAT_6_WEIGHT + "%)";
      }
      return ret;
    },
    can_cancel_and_publish() {
      const user = this.$store.state.auth.user.delegated_officer;
      return (
        user &&
        (user.privilege == 91 ||
          user.privilege == 40 ||
          user.privilege == 45)
      );
    },
    already_confirm() {
      return (
        this.current_curr_index_data &&
        this.current_curr_index_data.CONFIRMED_TIMESTAMP !== null
      );
    },
    already_publish() {
      return (
        this.current_curr_index_data &&
        this.current_curr_index_data.APPLIED_TIMESTAMP !== null
      );
    },
    confirmed_timestamp() {
      return this.current_curr_index_data &&
        this.current_curr_index_data.CONFIRMED_TIMESTAMP
        ? this.current_curr_index_data.CONFIRMED_TIMESTAMP
        : "";
    },
    applied_timestamp() {
      return this.current_curr_index_data &&
        this.current_curr_index_data.APPLIED_TIMESTAMP
        ? this.current_curr_index_data.APPLIED_TIMESTAMP
        : "";
    },

    sample_data() {
      return this.list_applicant[0];
    },
    filtered_data_field() {
      return this.data_field.filter((item) => {
        // ถ้าเป็นโหมดผู้ผ่านคัดเลือก แล้วต้องซ่อน
        if (
          item.hide_on_passed_mode &&
          this.passed_list_mode &&
          !this.selected_data[item.data_select]
        )
          return false;
        //-------------------------------------------------
        // ถ้าเป็นโหมดผู้ผ่านคัดเลือก แล้วต้อง show
        if (item.show_on_passed_mode && this.passed_list_mode) return true;
        //-------------------------------------------------
        // ถ้าแสดงตลอดเวลา
        if (item.mode === "always_show") return true;
        //-------------------------------------------------
        // ถ้าแสดงเฉพาะโหมดธรรมดา ไม่ละเอียด หรือโหมดละเอียดแล้วเลือก
        if (
          item.mode === "show_on_not_detail_mode_or_select" &&
          (!this.detail_mode ||
            (this.detail_mode && this.selected_data[item.data_select]))
        ) {
          return true;
        }
        //-------------------------------------------------
        // ถ้าเป็นช่องแสดงสถานะ
        if (
          item.mode === "status_field" &&
          (this.set_pass_mode || this.show_pass_mode)
        )
          return true;
        //-------------------------------------------------
        // ถ้าเป็นช่องแสดงสถานะ ของบัณฑิตเท่านั้น
        if (
          item.mode === "status_field_graduate" &&
          (this.set_pass_mode || this.show_pass_mode) &&
          (this.url_data.level_id === "2" || this.url_data.level_id === "3")
        )
          return true;
        //-------------------------------------------------
        // ถ้าให้แสดงเฉพาะตอนเลือกในโหมดละเอียด
        if (
          item.mode === "show_only_on_detail_mode" &&
          this.detail_mode &&
          this.selected_data[item.data_select]
        )
          return true;
        //-------------------------------------------------
        // ถ้าให้แสดงเฉพาะโหมดรายชื่อผู้ผ่าน
        if (
          item.mode === "show_only_on_passed_list_mode" &&
          this.passed_list_mode
        )
          return true;
        //-------------------------------------------------
        // ถ้าเป็นแสดงคะแนน GAT PAT // แสดงเฉพาะโหมด set pass กับ show pass ถ้าจะให้แสดงโหมดอื่นเพิ่มให้แก้ที่นี่
        if (
          item.mode === "gat_pat" &&
          // (this.set_pass_mode || this.show_pass_mode) &&
          this.display_gat_pat
        )
          return true;
        //-------------------------------------------------

        return false;
      });
    },
    // ข้อมูลทั่วไปผู้สมัคร
    nations: function() {
      return this.$store.state.ref.nations;
    },
    // ข้อมูลโรงเรียน
    schoolTypes: function() {
      return this.$store.state.ref.schoolTypes;
    },
    educationTypes: function() {
      return this.$store.state.ref.educationTypes;
    },
    schoolStudyStatuss: function() {
      return this.$store.state.ref.schoolStudyStatuss;
    },
    schoolStudyTypes: function() {
      return this.$store.state.ref.schoolStudyTypes;
    },
    // ข้อมูลมหาวิทยาลัย
    universitys: function() {
      return this.$store.state.ref.universitys;
    },
    universityStudyStatuss: function() {
      return this.$store.state.ref.universityStudyStatuss;
    },

    file_path() {
      return (
        process.env.VUE_APP_ENDPOINT +
        "admission/api/" +
        "?function=get-document-file&service_type=register&" +
        "response_type=file&REGISTER_ID="
      );
    },

    isAdditionalFilesExists() {
      let exists = false;
      this.list_applicant.map((item) => {
        if (item.ADDITIONAL_FILE == 1) exists = true;
      });
      return exists;
    },

    getDownloadAdditionalFilesPath() {
      let path =
        process.env.VUE_APP_ENDPOINT +
        "admission/api/?function=download-additional-files-zip";

      this.list_applicant.map((item) => {
        if (item.ADDITIONAL_FILE == 1)
          path = path + "&list[]=" + item.REGISTER_ID;
      });

      return path;
    },
  },
  methods: {
    objectTranslator,
    inlineTranslator,
    exportExcel,

    downloadExcel() {
      exportExcel(
        this.LEVEL_ID,
        this.YEAR,
        this.SEMESTER,
        this.PROJECT_NAME_TH,
        this.TYPE_DATA_TH,
        this.detail_mode,
        this.list_applicant,
        this.list_applicant_additional_data,
        this.passed_list_mode,
        this.selected_data,
        this.set_pass_mode,
        this.show_pass_mode,
        this.get_pass_order
      );
    },

    activate_detail_page(val) {
      this.detail_mode = val;
      this.set_pass_mode = false;
      this.list_applicant_additional_data = [];
    },

    activate_set_pass_page(val) {
      this.set_pass_mode = val;
      this.show_pass_mode = val;
      this.detail_mode = false;
    },

    activate_show_pass_page(val) {
      this.show_pass_mode = val;
    },

    update_inter(item, index, e) {
      //NOTICE: Cannot work in detail mode
      if (e === "0")
        item.regis_status[0].PAYMENT_CONFIRM_FEE = item.PACKAGE_FEE;
      if (e === "1")
        item.regis_status[0].PAYMENT_CONFIRM_FEE = item.PACKAGE_FEE_INTER;

      this.$set(this.list_applicant, index, { ...item });
    },

    async fetch_simple_data() {
      const data = await this.fetch_data();
      this.list_applicant = data;
      if (data.length > 0) {
        this.$set(this.list_applicant, 0, data[0]);
      }
    },

    async fetch_additional_data(params) {
      let data = await this.fetch_data(params);
      data.map((item) => {
        // ข้อมูลทั่วไปผู้สมัคร
        if (item.NATION_ID) {
          const ref_data = getById(this.nations, item.NATION_ID, "NATION_ID");
          item.NATION_NAME_EN = ref_data.NATION_NAME_EN;
          item.NATION_NAME_TH = ref_data.NATION_NAME_TH;
        }
        // ข้อมูลประวัติโรงเรียน กรณีสมัครระดับปริญญาตรี
        if (item.edubg_ungrad_SCHOOL_TYPE_ID) {
          const ref_data = getById(
            this.schoolTypes,
            item.edubg_ungrad_SCHOOL_TYPE_ID,
            "SCHOOL_TYPE_ID"
          );
          item.SCHOOL_TYPE_NAME_EN = ref_data.SCHOOL_TYPE_NAME_EN;
          item.SCHOOL_TYPE_NAME_TH = ref_data.SCHOOL_TYPE_NAME_TH;
        }
        // --------------------------------------------------------------
        if (item.edubg_ungrad_EDUCATION_TYPE_ID) {
          const ref_data = getById(
            this.educationTypes,
            item.edubg_ungrad_EDUCATION_TYPE_ID,
            "EDUCATION_TYPE_ID"
          );
          item.EDUCATION_TYPE_NAME_EN = ref_data.EDUCATION_TYPE_NAME_EN;
          item.EDUCATION_TYPE_NAME_TH = ref_data.EDUCATION_TYPE_NAME_TH;
          if (item.edubg_ungrad_EDUCATION_TYPE_ID === "90") {
            item.EDUCATION_TYPE_NAME_EN =
              item.EDUCATION_TYPE_NAME_EN +
              " : " +
              item.edubg_ungrad_EDUCATION_OTHER;
            item.EDUCATION_TYPE_NAME_TH =
              item.EDUCATION_TYPE_NAME_TH +
              " : " +
              item.edubg_ungrad_EDUCATION_OTHER;
          }
        }
        // --------------------------------------------------------------
        if (item.edubg_ungrad_STUDY_STATUS_ID) {
          const ref_data = getById(
            this.schoolStudyStatuss,
            item.edubg_ungrad_STUDY_STATUS_ID,
            "SCHOOL_STUDY_STATUS_ID"
          );
          item.SCHOOL_STUDY_STATUS_NAME_EN =
            ref_data.SCHOOL_STUDY_STATUS_NAME_EN;
          item.SCHOOL_STUDY_STATUS_NAME_TH =
            ref_data.SCHOOL_STUDY_STATUS_NAME_TH;
        }
        // --------------------------------------------------------------
        if (item.edubg_ungrad_STUDY_TYPE_ID) {
          const ref_data = getById(
            this.schoolStudyTypes,
            item.edubg_ungrad_STUDY_TYPE_ID,
            "SCHOOL_STUDY_TYPE_ID"
          );
          item.SCHOOL_STUDY_TYPE_NAME_EN = ref_data.SCHOOL_STUDY_TYPE_NAME_EN;
          item.SCHOOL_STUDY_TYPE_NAME_TH = ref_data.SCHOOL_STUDY_TYPE_NAME_TH;
        }
        // --------------------------------------------------------------
        // ข้อมูลประวัติโรงเรียน กรณีสมัครระดับบัณฑิต
        if (item.edubg_grad_MASTER_COUNTRY_ID_OF_UNIVERSITY === "TH") {
          const ref_data = getById(
            this.universitys,
            item.edubg_grad_MASTER_UNIVERSITY_ID,
            "UNIVERSITY_ID"
          );
          item.MASTER_UNIVERSITY_NAME_EN = ref_data.UNIVERSITY_NAME_EN;
          item.MASTER_UNIVERSITY_NAME_TH = ref_data.UNIVERSITY_NAME_TH;
        }
        if (item.edubg_grad_UNIVERSITY_STUDY_STATUS) {
          const ref_data = getById(
            this.universityStudyStatuss,
            item.edubg_grad_UNIVERSITY_STUDY_STATUS,
            "UNIVERSITY_STUDY_STATUS_ID"
          );
          item.UNIVERSITY_STUDY_STATUS_NAME_EN =
            ref_data.UNIVERSITY_STUDY_STATUS_NAME_EN;
          item.UNIVERSITY_STUDY_STATUS_NAME_TH =
            ref_data.UNIVERSITY_STUDY_STATUS_NAME_TH;
        }
        if (item.edubg_grad_MASTER_UNIVERSITY_STUDY_STATUS) {
          const ref_data = getById(
            this.universityStudyStatuss,
            item.edubg_grad_MASTER_UNIVERSITY_STUDY_STATUS,
            "UNIVERSITY_STUDY_STATUS_ID"
          );
          item.MASTER_UNIVERSITY_STUDY_STATUS_NAME_EN =
            ref_data.UNIVERSITY_STUDY_STATUS_NAME_EN;
          item.MASTER_UNIVERSITY_STUDY_STATUS_NAME_TH =
            ref_data.UNIVERSITY_STUDY_STATUS_NAME_TH;
        }
        // --------------------------------------------------------------
        return item;
      });
      this.list_applicant_additional_data = data;
    },

    search_detail() {
      const selected_data = this.$refs.data_selector.get_attribute();
      this.selected_data = selected_data;
      let params = {};

      // ---------ข้อมูลประวัติโรงเรียน กรณีสมัครระดับปริญญาตรี-----------
      if (selected_data.school_type) {
        if (!params.select_edubg_ungrad) params.select_edubg_ungrad = [];
        params.select_edubg_ungrad.push("SCHOOL_TYPE_ID");
      }
      if (selected_data.education_type) {
        if (!params.select_edubg_ungrad) params.select_edubg_ungrad = [];
        params.select_edubg_ungrad.push("EDUCATION_TYPE_ID");
      }

      if (selected_data.study_status) {
        if (!params.select_edubg_ungrad) params.select_edubg_ungrad = [];
        params.select_edubg_ungrad.push("STUDY_STATUS_ID");
      }
      if (selected_data.study_type) {
        if (!params.select_edubg_ungrad) params.select_edubg_ungrad = [];
        params.select_edubg_ungrad.push("STUDY_TYPE_ID");
      }
      if (selected_data.term_of_gpa) {
        if (!params.select_edubg_ungrad) params.select_edubg_ungrad = [];
        params.select_edubg_ungrad.push("TERM_OF_GPA");
      }
      if (selected_data.gpa) {
        if (!params.select_edubg_ungrad) params.select_edubg_ungrad = [];
        params.select_edubg_ungrad.push("GPA");
      }
      //---------ข้อมูลเพิ่มเติม สำหรับนานาชาติ----------
      if (selected_data.inter_info) {
        if (!params.select_edubg_inter) params.select_edubg_inter = [];
        params.select_edubg_inter.push("DIPLOMA_TYPE");
        params.select_edubg_inter.push("SUBJECT_1_NAME");
        params.select_edubg_inter.push("SUBJECT_1_SCORE");
        params.select_edubg_inter.push("SUBJECT_1_TEST_DATE");
        params.select_edubg_inter.push("SUBJECT_2_NAME");
        params.select_edubg_inter.push("SUBJECT_2_SCORE");
        params.select_edubg_inter.push("SUBJECT_2_TEST_DATE");
        params.select_edubg_inter.push("SUBJECT_3_NAME");
        params.select_edubg_inter.push("SUBJECT_3_SCORE");
        params.select_edubg_inter.push("SUBJECT_3_TEST_DATE");
        params.select_edubg_inter.push("GED_RTLA_SCORE");
        params.select_edubg_inter.push("GED_MR_SCORE");
        params.select_edubg_inter.push("GED_SCI_SCORE");
        params.select_edubg_inter.push("GED_SS_SCORE");
        params.select_edubg_inter.push("GED_TEST_DATE");

        params.select_edubg_inter.push("SAT_1_MATH_SCORE");
        params.select_edubg_inter.push("SAT_1_RW_SCORE");
        params.select_edubg_inter.push("SAT_1_TOTAL_SCORE");
        params.select_edubg_inter.push("SAT_1_TEST_DATE");
        params.select_edubg_inter.push("OLD_SAT_VERBAL_SCORE");
        params.select_edubg_inter.push("OLD_SAT_MATH_SCORE");
        params.select_edubg_inter.push("OLD_SAT_WRITING_SCORE");
        params.select_edubg_inter.push("OLD_SAT_TEST_DATE");
        params.select_edubg_inter.push("SAT_2_BIO_SCORE");
        params.select_edubg_inter.push("SAT_2_CHEM_SCORE");
        params.select_edubg_inter.push("SAT_2_PHY_SCORE");
        params.select_edubg_inter.push("SAT_2_MATH_SCORE");
        params.select_edubg_inter.push("SAT_2_TEST_DATE");
        params.select_edubg_inter.push("ACT_SCORE");
        params.select_edubg_inter.push("ACT_TEST_DATE");
        params.select_edubg_inter.push("IB_SCORE");
        params.select_edubg_inter.push("IB_TEST_DATE");
        params.select_edubg_inter.push("GAT_1_SCORE");
        params.select_edubg_inter.push("GAT_2_SCORE");
        params.select_edubg_inter.push("GAT_TEST_DATE");
        params.select_edubg_inter.push("PAT_1_SCORE");
        params.select_edubg_inter.push("PAT_3_SCORE");
        params.select_edubg_inter.push("PAT_TEST_DATE");
        params.select_edubg_inter.push("TOFEL_SCORE");
        params.select_edubg_inter.push("TOFEL_TEST_DATE");
        params.select_edubg_inter.push("IELTS_SCORE");
        params.select_edubg_inter.push("IELTS_TEST_DATE");
        params.select_edubg_inter.push("KMITL_TEP_SCORE");
        params.select_edubg_inter.push("KMITL_TEP_TEST_DATE");
        params.select_edubg_inter.push("OTHER_NAME");
        params.select_edubg_inter.push("OTHER_SCORE");
        params.select_edubg_inter.push("OTHER_TEST_DATE");
      }
      //---------ข้อมูลเพิ่มเติม สำหรับแพทย์----------
      if (selected_data.med_info) {
        if (!params.select_edubg_medicine) params.select_edubg_medicine = [];
        params.select_edubg_medicine.push("DIPLOMA_TYPE");
        params.select_edubg_medicine.push("SAT_2_BIO_SCORE");
        params.select_edubg_medicine.push("SAT_2_CHEM_SCORE");
        params.select_edubg_medicine.push("SAT_2_PHY_SCORE");
        params.select_edubg_medicine.push("SAT_2_MATH_SCORE");
        params.select_edubg_medicine.push("SAT_2_TEST_DATE");
        params.select_edubg_medicine.push("BMAT_SECTION_1_SCORE");
        params.select_edubg_medicine.push("BMAT_SECTION_2_SCORE");
        params.select_edubg_medicine.push("BMAT_SECTION_3_SCORE");
        params.select_edubg_medicine.push("BMAT_TEST_DATE");
        params.select_edubg_medicine.push("SPOT_SCORE");
        params.select_edubg_medicine.push("SPOT_TEST_DATE");
        params.select_edubg_medicine.push("TOEFL_IBT_SCORE");
        params.select_edubg_medicine.push("TOEFL_PBT_SCORE");
        params.select_edubg_medicine.push("TOEFL_CBT_SCORE");
        params.select_edubg_medicine.push("TOFEL_TEST_DATE");
        params.select_edubg_medicine.push("IELTS_SCORE");
        params.select_edubg_medicine.push("IELTS_TEST_DATE");
        params.select_edubg_medicine.push("CU_TEP_SCORE");
        params.select_edubg_medicine.push("CU_TEP_TEST_DATE");
        params.select_edubg_medicine.push("PERSONAL_STATEMENT");
      }
      //---------ข้อมูลประวัติการศึกษา กรณีสมัครระดับบัณฑิตศึกษา----------
      if (selected_data.undergraduate_info) {
        if (!params.select_edubg_grad) params.select_edubg_grad = [];
        params.select_edubg_grad.push("COUNTRY_ID_OF_UNIVERSITY");
        params.select_edubg_grad.push("UNIVERSITY_NAME");
        params.select_edubg_grad.push("UNIVERSITY_ID");
        params.select_edubg_grad.push("GRADUATED_YEAR");
        params.select_edubg_grad.push("UNIVERSITY_STUDY_STATUS");
        params.select_edubg_grad.push("DEGREE_NAME");
        params.select_edubg_grad.push("CURRICULUM_NAME");
        params.select_edubg_grad.push("GPA");
      }
      if (selected_data.master_info) {
        if (!params.select_edubg_grad) params.select_edubg_grad = [];
        params.select_edubg_grad.push("MASTER_COUNTRY_ID_OF_UNIVERSITY");
        params.select_edubg_grad.push("MASTER_UNIVERSITY_NAME");
        params.select_edubg_grad.push("MASTER_UNIVERSITY_ID");
        params.select_edubg_grad.push("MASTER_GRADUATED_YEAR");
        params.select_edubg_grad.push("MASTER_UNIVERSITY_STUDY_STATUS");
        params.select_edubg_grad.push("MASTER_DEGREE_NAME");
        params.select_edubg_grad.push("MASTER_CURRICULUM_NAME");
        params.select_edubg_grad.push("MASTER_GPA");
      }
      // -----------------ข้อมูลประกอบผู้สมัคร------------------------
      if (selected_data.constarint_2) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_2");
      }
      if (selected_data.constarint_3) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_3");
      }
      if (selected_data.constarint_4) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_4");
      }
      if (selected_data.constarint_5) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_5");
      }
      if (selected_data.constarint_6) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_6");
      }
      if (selected_data.constarint_7) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_7");
      }
      if (selected_data.constarint_8) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_8");
      }
      if (selected_data.constarint_9) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_9");
      }
      if (selected_data.constarint_10) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_10");
      }
      if (selected_data.constarint_11) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_11");
      }
      if (selected_data.constarint_12) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_12");
      }
      if (selected_data.constarint_13) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_13");
      }
      if (selected_data.constarint_14) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_14");
      }
      if (selected_data.constarint_15) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_15");
      }
      if (selected_data.constarint_16) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_16");
      }
      if (selected_data.constarint_17) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_17");
      }
      if (selected_data.constarint_18) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_18");
      }
      if (selected_data.constarint_20) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_20");
      }
      if (selected_data.constarint_21) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_21");
      }
      if (selected_data.constarint_22) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_22");
      }
      if (selected_data.constarint_23) {
        if (!params.select_user_constraint) params.select_user_constraint = [];
        params.select_user_constraint.push("CONSTRAINT_ID_23");
      }
      // ---------------------------------------------------------
      this.fetch_additional_data(params);
    },

    async fetch_data(additional_data = null) {
      this.loading = true;
      const url_data = this.$route.query;
      let query_param = {};

      if (url_data.passed_list_mode === "true") this.passed_list_mode = true;
      if (url_data.selective_mode === "true") this.selective_mode = true;

      this.LEVEL_ID = url_data.level_id;
      this.YEAR = url_data.YEAR;
      this.SEMESTER = url_data.SEMESTER;
      this.ROUND_NAME_TH = url_data.ROUND_NAME_TH;
      this.ROUND_NAME_EN = url_data.ROUND_NAME_EN;
      this.PROJECT_NAME_TH = url_data.PROJECT_NAME_TH;
      this.PROJECT_NAME_EN = url_data.PROJECT_NAME_EN;
      this.FACULTY_NAME_TH = url_data.FACULTY_NAME_TH;
      this.FACULTY_NAME_EN = url_data.FACULTY_NAME_EN;
      this.CURRICULUM_NAME_TH = url_data.CURRICULUM_NAME_TH;
      this.CURRICULUM_NAME_EN = url_data.CURRICULUM_NAME_EN;
      if (url_data.BRANCH_NAME_TH) {
        this.BRANCH_NAME_TH = url_data.BRANCH_NAME_TH;
        this.BRANCH_NAME_EN = url_data.BRANCH_NAME_EN;
      }
      if (url_data.level_id == "2" || url_data.level_id == "3") {
        this.STUDY_ADMIT_TYPE_NAME_TH = url_data.STUDY_ADMIT_TYPE_NAME_TH;
        this.STUDY_ADMIT_TYPE_NAME_EN = url_data.STUDY_ADMIT_TYPE_NAME_EN;
        this.STUDY_PLAN_NAME_TH = url_data.STUDY_PLAN_NAME_TH;
        this.STUDY_PLAN_NAME_EN = url_data.STUDY_PLAN_NAME_EN;
        this.STUDY_CLASSES_NAME_TH = url_data.STUDY_CLASSES_NAME_TH;
        this.STUDY_CLASSES_NAME_EN = url_data.STUDY_CLASSES_NAME_EN;
        this.SPECIFIC_NATION_NAME_TH = url_data.SPECIFIC_NATION_NAME_TH;
        this.SPECIFIC_NATION_NAME_EN = url_data.SPECIFIC_NATION_NAME_EN;
      }
      this.TYPE_DATA_TH = url_data.TYPE_DATA_TH;
      this.TYPE_DATA_EN = url_data.TYPE_DATA_EN;
      this.COUNT_TOTAL = url_data.COUNT_TOTAL;

      if (url_data.year_id) query_param.year_id = url_data.year_id;

      if (url_data.project_id && url_data.project_id !== "all")
        query_param.project_id = url_data.project_id;

      if (url_data.round_id) query_param.round_id = url_data.round_id;

      if (url_data.faculty_id) query_param.faculty_id = url_data.faculty_id;

      if (url_data.curriculum_id)
        query_param.master_reg_curriculum_id = url_data.curriculum_id;

      if (url_data.branch_id) query_param.branch_id = url_data.branch_id;

      if (url_data.level_id == "2" || url_data.level_id == "3") {
        if (url_data.study_admit_type_id) {
          query_param.study_admit_type_id = url_data.study_admit_type_id;
        } else {
          this.STUDY_ADMIT_TYPE_NAME_EN = "All";
          this.STUDY_ADMIT_TYPE_NAME_TH = "ทั้งหมด";
        }
        if (url_data.study_plan_id) {
          query_param.study_plan_id = url_data.study_plan_id;
        } else {
          this.STUDY_PLAN_NAME_EN = "All";
          this.STUDY_PLAN_NAME_TH = "ทั้งหมด";
        }
        if (url_data.study_classes_id) {
          query_param.study_classes_id = url_data.study_classes_id;
        } else {
          this.STUDY_CLASSES_NAME_EN = "All";
          this.STUDY_CLASSES_NAME_TH = "ทั้งหมด";
        }
        if (url_data.specific_nation_id) {
          query_param.specific_nation_id = url_data.specific_nation_id;
        } else {
          this.SPECIFIC_NATION_NAME_EN = "All";
          this.SPECIFIC_NATION_NAME_TH = "ทั้งหมด";
        }
      }

      if (url_data.refused) query_param.refused = url_data.refused;

      if (url_data.order) query_param.order = url_data.order;

      if (url_data.status === "0") query_param.static_list = "1";

      if (url_data.status === "2") query_param.register_status_id = "2";

      if (url_data.status === "3") query_param.register_status_id = "3";

      if (url_data.status === "4") query_param.register_status_id = "4";

      if (url_data.status === "5") query_param.register_status_id = "5";

      if (url_data.status === "6") query_param.register_status_id = "6";

      if (additional_data) {
        query_param.additional_data = additional_data;
      }

      let data;
      if (this.passed_list_mode) {
        if (this.cache_getPreExecutedNameListSummary) {
          data = this.cache_getPreExecutedNameListSummary;
        } else {
          data = await reportsService.getPreExecutedNameListSummary(
            query_param
          );
          this.cache_getPreExecutedNameListSummary = data;
        }
        data = data.filter(
          (item) => item.PAUSED === "0" && item.PASSED === "1"
        );
      } else {
        if (additional_data) {
          data = await reportsService.getNameListSummary(query_param);
          this.cache_getNameListSummary = data;
        } else if (this.cache_getNameListSummary) {
          data = this.cache_getNameListSummary;
        } else {
          data = await reportsService.getNameListSummary(query_param);
          this.cache_getNameListSummary = data;
        }
      }

      this.url_data = url_data;

      if (
        (url_data.level_id === "1" &&
          url_data.year_id &&
          url_data.round_id &&
          url_data.project_id &&
          url_data.project_id !== "all" &&
          url_data.faculty_id &&
          url_data.curriculum_id &&
          url_data.order) ||
        ((url_data.level_id === "2" || url_data.level_id === "3") &&
          url_data.year_id &&
          url_data.round_id &&
          url_data.project_id &&
          url_data.project_id !== "all" &&
          url_data.faculty_id &&
          url_data.curriculum_id &&
          url_data.order &&
          url_data.study_admit_type_id &&
          url_data.study_plan_id &&
          url_data.study_classes_id)
      ) {
        const data_status = await reportsService
          .getPreExecutedRegister({
            YEAR_ID: url_data.year_id,
            ROUND_ID: url_data.round_id,
            PROJECT_ID: url_data.project_id,
            FACULTY_ID: url_data.faculty_id,
          })
          .catch((error) =>
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            })
          );

        if (data_status) {
          this.set_status_mode_available = true;
          data.map((item_data) => {
            let regis_status = data_status.filter(
              (i) => i.REGISTER_ID === item_data.REGISTER_ID
            );
            regis_status = regis_status.map((i) => ({
              ...i,
              PAYMENT_CONFIRM_FEE: i.PAYMENT_CONFIRM_FEE
                ? i.PAYMENT_CONFIRM_FEE
                : item_data.PACKAGE_FEE,
            }));
            item_data.regis_status = regis_status;
            const current_status = regis_status.find(
              (i) => i.ADMISSION_CURRICULUM_ID === item_data.CURRICULUM_ID
            );
            item_data.not_set = !current_status;
            item_data.passed = current_status && current_status.PASSED === "1";
            item_data.paused = current_status && current_status.PAUSED === "1";
          });
        }
      }

      const index_data = await reportsService.getExecuteIndex({
        YEAR_ID: url_data.year_id,
        ROUND_ID: url_data.round_id,
        PROJECT_ID:
          url_data.project_id && url_data.project_id !== "all"
            ? url_data.project_id
            : null,
      });
      const current_curr_index_data = index_data.find(
        (i) =>
          i.MASTER_REG_CURRICULUM_ID === url_data.curriculum_id &&
          (url_data.branch_id ? i.BRANCH_ID === url_data.branch_id : true) &&
          (url_data.study_admit_type_id
            ? i.STUDY_ADMIT_TYPE_ID === url_data.study_admit_type_id
            : true) &&
          (url_data.study_plan_id
            ? i.STUDY_PLAN_ID === url_data.study_plan_id
            : true) &&
          (url_data.study_classes_id
            ? i.STUDY_CLASSES_ID === url_data.study_classes_id
            : true)
      );
      if (current_curr_index_data) {
        this.current_curr_index_data = current_curr_index_data;
        if (current_curr_index_data.show_gat_pat_score === "1")
          this.display_gat_pat = true;
      }

      this.loading = false;
      return data;
    },

    style_by_status(item) {
      let color = "";
      // ไม่อยู่ในโหมดตั้งสถานะ
      if (!this.set_pass_mode && !this.show_pass_mode) return "";
      // ยังไม่เคยตั้ง
      if (!item.length === 0) return "";
      // ไม่มีอันไหนผ่าน
      if (
        item.reduce(
          (ret, i) => i.PASSED === "0" && i.PAUSED === "0" && ret,
          true
        )
      )
        return "";
      // มีอันผ่าน เป็นของหลักสูตรตัวเอง
      if (
        // กรณีกด ผ่าน
        item.filter(
          (i) =>
            i.ADMISSION_CURRICULUM_ID ===
              this.url_data.admission_curriculum_id && i.PASSED === "1"
        ).length > 0
      )
        color = "#96f069";
      else if (
        // กรณีกด รอ
        item.filter(
          (i) =>
            i.ADMISSION_CURRICULUM_ID ===
              this.url_data.admission_curriculum_id && i.PAUSED === "1"
        ).length > 0
      )
        color = "#ffff00";
      // เหลือเคสมีอันผ่าน ของหลักสูตรอื่น
      else color = "orange";

      return `background-color: ${color};`;
    },

    is_editable(item) {
      // ไม่อยู่ในโหมดตั้งสถานะ
      if (!this.set_pass_mode) return false;
      // ยังไม่เคยตั้ง
      if (!item.length === 0) return true;
      // ไม่มีอันไหนผ่าน
      if (item.reduce((ret, i) => i.PASSED === "0" && ret, true)) return true;
      // มีอันผ่าน เป็นของหลักสูตรตัวเอง
      if (
        item.filter(
          (i) =>
            i.ADMISSION_CURRICULUM_ID ===
              this.url_data.admission_curriculum_id && i.PASSED === "1"
        ).length > 0
      )
        return true;
      // เหลือเคสมีอันผ่าน ของหลักสูตรอื่น
      else return false;
    },

    get_pass_order(item) {
      if (!item) return "-";
      const pass_item = item.find((i) => i.PASSED === "1");
      if (pass_item) return pass_item.ORDER;
      else return "-";
    },

    async save_payment(item) {
      await reportsService
        .setPreExecutedRegister({
          YEAR_ID: this.url_data.year_id,
          ROUND_ID: this.url_data.round_id,
          PROJECT_ID:
            this.url_data.project_id && this.url_data.project_id !== "all"
              ? this.url_data.project_id
              : null,
          FACULTY_ID: this.url_data.faculty_id,
          register_list: item.regis_status[0],
        })
        .catch((error) =>
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          })
        );
      this.fetch_simple_data();
    },

    async set_status(applicant_item, status) {
      await reportsService
        .setPreExecutedRegister({
          YEAR_ID: this.url_data.year_id,
          ROUND_ID: this.url_data.round_id,
          PROJECT_ID:
            this.url_data.project_id && this.url_data.project_id !== "all"
              ? this.url_data.project_id
              : null,
          FACULTY_ID: this.url_data.faculty_id,
          register_list: {
            REGISTER_ID: applicant_item.REGISTER_ID,
            ADMISSION_CURRICULUM_ID: applicant_item.CURRICULUM_ID,
            PASSED: status,
            ORDER: this.url_data.order,
            PAUSED: 0,
          },
        })
        .catch((error) =>
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          })
        );
      this.fetch_simple_data();
    },

    async set_pause_status(applicant_item, pause) {
      await reportsService
        .setPreExecutedRegister({
          YEAR_ID: this.url_data.year_id,
          ROUND_ID: this.url_data.round_id,
          PROJECT_ID:
            this.url_data.project_id && this.url_data.project_id !== "all"
              ? this.url_data.project_id
              : null,
          FACULTY_ID: this.url_data.faculty_id,
          register_list: {
            REGISTER_ID: applicant_item.REGISTER_ID,
            ADMISSION_CURRICULUM_ID: applicant_item.CURRICULUM_ID,
            PASSED: "",
            ORDER: this.url_data.order,
            PAUSED: pause,
          },
        })
        .catch((error) =>
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          })
        );
      this.fetch_simple_data();
    },

    async confirm_lock(lock = true) {
      this.loading = true;
      const response = await reportsService
        .setPreExecutedRegisterLock({
          YEAR_ID: this.url_data.year_id,
          ROUND_ID: this.url_data.round_id,
          PROJECT_ID:
            this.url_data.project_id && this.url_data.project_id !== "all"
              ? this.url_data.project_id
              : null,
          FACULTY_ID: this.url_data.faculty_id,
          MASTER_REG_CURRICULUM_ID: this.url_data.curriculum_id,
          BRANCH_ID: this.url_data.branch_id,
          STUDY_ADMIT_TYPE_ID: this.url_data.study_admit_type_id,
          STUDY_PLAN_ID: this.url_data.study_plan_id,
          STUDY_CLASSES_ID: this.url_data.study_classes_id,
          SPECIFIC_NATION_ID: this.url_data.specific_nation_id,
          lock: lock,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });
      if (response && response.status) {
        this.loading = false;
        this.$toasted.success(this.$t("toasted.save_successfully"), {
          duration: 0,
        });
        this.cancel_dialog = false;
        this.open_lock_confirm = false;
        this.publish_dialog = false;
        this.fetch_simple_data();
      }
    },

    async publish(mode = null) {
      this.loading = true;
      const response = await reportsService
        .publish({
          YEAR_ID: this.url_data.year_id,
          ROUND_ID: this.url_data.round_id,
          PROJECT_ID:
            this.url_data.project_id && this.url_data.project_id !== "all"
              ? this.url_data.project_id
              : null,
          FACULTY_ID: this.url_data.faculty_id,
          MASTER_REG_CURRICULUM_ID: this.url_data.curriculum_id,
          BRANCH_ID: this.url_data.branch_id,
          STUDY_ADMIT_TYPE_ID: this.url_data.study_admit_type_id,
          STUDY_PLAN_ID: this.url_data.study_plan_id,
          STUDY_CLASSES_ID: this.url_data.study_classes_id,
          SPECIFIC_NATION_ID: this.url_data.specific_nation_id,
          mode: mode,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });
      if (response && response.status) {
        this.loading = false;
        this.$toasted.success(this.$t("toasted.save_successfully"), {
          duration: 0,
        });
        this.cancel_dialog = false;
        this.open_lock_confirm = false;
        this.publish_dialog = false;
        this.cache_getPreExecutedNameListSummary = null;
        this.fetch_simple_data();
      }
    },

    async init() {
      await this.$store.dispatch("ref/getSchoolTypes");
      await this.$store.dispatch("ref/getEducationTypes");
      await this.$store.dispatch("ref/getSchoolStudyStatuss");
      await this.$store.dispatch("ref/getSchoolStudyTypes");
      await this.$store.dispatch("ref/getNations");
      await this.$store.dispatch("ref/getUniversitys");
      await this.$store.dispatch("ref/getUniversityStudyStatuss");
      await this.fetch_simple_data();
    },
  },
  mounted: function() {
    this.init();
  },
};
</script>

<style scoped>
th {
  overflow: hidden;
  white-space: nowrap;
  border-width: 1px;
  border-right-width: 0;
  border-style: solid;
  border-color: rgb(211, 211, 211);
}
td {
  overflow: hidden;
  white-space: nowrap;
  border-width: 1px;
  border-right-width: 0;
  border-style: solid;
  border-color: rgb(211, 211, 211);
}
</style>
